import { MerchantResponse } from 'lib/generated/api'
import { WorkspaceMerchant, WorkspaceMerchantsPage } from 'types/entities'

export type WorkspaceMerchantsPageMapper = (
  response: MerchantResponse
) => WorkspaceMerchantsPage

export const mapToWorkspaceMerchantsPage: WorkspaceMerchantsPageMapper = response => {
  const mappedResults: WorkspaceMerchant[] = response.results.map(merchant => ({
    id: merchant.merchantId,
    name: merchant.name || '',
    address: merchant.address?.addressLine1 || '',
    inMerchantNetwork: merchant.inMerchantNetwork || false,
  }))
  return {
    results: mappedResults,
    paginationToken: response.paginationToken,
    hasNextPage: response.hasNextPage,
    hasPreviousPage: response.hasPreviousPage,
  }
}
